import { MeRepository, DevicesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

/**
 * Lock device controller
 * Handles lock-device modal template.
 */

angular.module('controllers')
    .controller('LockDevice', ($scope, $stateParams) => {

        const { deviceId } = $stateParams;

        $scope.userId = MeRepository.getMyId();
        $scope.device = DevicesRepository.getById(deviceId);

        $scope.lockDevice = () => {

            Mixpanel.send('Click Confirm Lock Device Modal');

        };

    });



// WEBPACK FOOTER //
// ./scripts/controllers/modals/lock-device.js